// 暗黑主题
import { useMemo } from 'react';
import { theme } from 'antd';

export const darkThemeToken = {};

export const createDarkThemeConfig = () => ({
  theme: {
    algorithm: theme.darkAlgorithm,
    token: darkThemeToken,
  },
});

const useDarkTheme = () => {
  return useMemo(() => createDarkThemeConfig(), []);
};

export default useDarkTheme;
